import { z } from 'zod';

export interface LoginResponse {
  token?: string;
  message?: string;
  show_modal?: boolean;
  email?: string;
  error?: string;
}

export interface RegisterResponse {
  token?: string;
  message?: string;
  email?: string;
  error?: string;
}

export interface UserRegistrationData {
  email: string;
  password?: string;
  code?: string;
}
export interface LoginResponse {
  token?: string;
  message?: string;
  email?: string;
  error?: string;
}

export interface UserLoginData {
  email: string;
  password?: string;
  code?: string;
}
export interface PasswordData {
  password: string;
  uidb64: string;
  token: string;
}
export interface forgotPasswordEmail {
  email: string;
}
export interface codeForgotPasswordToken {
  uidb64: string;
  token: string;
}

export const schemaStep1 = z.object({
  email: z.string().min(1, 'required field'),
});

export const schemaStep2 = z.object({
  uidb64: z.string().min(4, 'Code must be 6 digits').max(6, 'Code must be 6 digits'),
  token: z.string().min(1, 'required field'),
});

export const schemaStep3 = z
  .object({
    password: z
      .string()
      .min(8, 'Use at least 8 characters')
      .regex(/[a-zA-Z]/, 'Include at least one letter')
      .regex(/[0-9]/, 'Include at least one number'),
    confirmPassword: z.string().min(1, 'Confirm Password is required'),
    uidb64: z.string().min(4, 'Code must be 6 digits').max(6, 'Code must be 6 digits'),
    token: z.string().min(1, 'required field'),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });

export const schemaStep1Login = z.object({
  email: z.string().min(1, 'required field'),
  password: z.string().min(1, 'required field'),
});

export const schemaStep2Login = z.object({
  email: z.string().min(1, 'required field'),
  code: z.string().min(6, 'Code must be 6 digits').max(6, 'Code must be 6 digits'),
});
export const schemaStep1Register = z
  .object({
    email: z.string().email('Invalid email format').min(1, 'Email is required'),
    password: z
      .string()
      .min(8, 'Use at least 8 characters')
      .regex(/[a-zA-Z]/, 'Include at least one letter')
      .regex(/[0-9]/, 'Include at least one number'),
    confirmPassword: z.string().min(1, 'Confirm Password is required'),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });
